import { Component } from '@angular/core';

@Component({
  selector: 'ui-item',
  templateUrl: './item.component.html'
})
export class ItemComponent {
}